import { render, staticRenderFns } from "./dettaglioFattura.vue?vue&type=template&id=27f4bf05"
import script from "./dettaglioFattura.vue?vue&type=script&lang=js"
export * from "./dettaglioFattura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports